var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWiSmog(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.35,12.46c0-0.94,0.3-1.77,0.9-2.5s1.37-1.21,2.31-1.43c0.23-1.11,0.79-2.03,1.7-2.75c0.91-0.72,1.95-1.08,3.12-1.08 c1.12,0,2.13,0.35,3,1.04c0.88,0.69,1.45,1.59,1.72,2.7h0.28c0.76,0,1.46,0.16,2.12,0.49s1.18,0.77,1.57,1.34 c0.39,0.57,0.59,1.18,0.59,1.84c0,1.12-0.43,2.08-1.29,2.86c0,0.35-0.11,0.75-0.32,1.2c-0.22,0.45-0.5,0.86-0.87,1.23 c-0.36,0.37-0.73,0.59-1.1,0.68c-0.12,0.62-0.41,1.14-0.86,1.57s-0.99,0.71-1.63,0.85c0.3,0.3,0.45,0.65,0.45,1.06 c0,0.49-0.17,0.91-0.52,1.26c-0.35,0.35-0.77,0.52-1.27,0.52c-0.49,0-0.91-0.17-1.26-0.52c-0.35-0.35-0.53-0.77-0.53-1.26 c0-0.06,0.01-0.14,0.04-0.26s0.04-0.21,0.04-0.27h-0.08c-0.59,0-1.09-0.21-1.51-0.63c-0.42-0.42-0.63-0.93-0.63-1.51 c0-0.23,0.12-0.58,0.37-1.06c-0.49-0.26-0.88-0.67-1.17-1.26h-1.25c-1.09-0.09-2.02-0.53-2.78-1.3C6.73,14.49,6.35,13.55,6.35,12.46 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWiSmog);
export default __webpack_public_path__ + "static/media/wi-smog.1ee26eaa7763405390e12c514d489b3b.svg";
export { ForwardRef as ReactComponent };